import type { ReactNode } from 'react';

export const symbol_custom_more_horiz: ReactNode = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 12 12"
		fill="currentColor">
		<path d="M3 5C2.45 5 2 5.45 2 6C2 6.55 2.45 7 3 7C3.55 7 4 6.55 4 6C4 5.45 3.55 5 3 5ZM9 5C8.45 5 8 5.45 8 6C8 6.55 8.45 7 9 7C9.55 7 10 6.55 10 6C10 5.45 9.55 5 9 5ZM6 5C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5Z" />
	</svg>
);
